import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  message,
  Cascader,
} from "antd";
import stationApi from "@api/station";
import SystemApi from "@api/sys";
import { findAllParents } from "../../../../utils/common";

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const fieldNames = {
  label: "itemName",
  value: "id",
  children: "children",
};

export default ({ onCancel, formState = {}, diyAttrList = [] }) => {
  const userInfo = sessionStorage.getItem("userInfo")
    ? JSON.parse(sessionStorage.getItem("userInfo"))
    : {};
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deviceList, setDeviceList] = useState([]);

  useEffect(() => {
    if (formState.id) {
      form.setFieldsValue({
        ...formState,
        deviceDiyAttrId: formState.deviceDiyAttrId * 1,
      });
    }
    setVisible(true);
    getDevice();
  }, []);

  const getDevice = () => {
    stationApi.getDeviceByStationId({ stationId }).then((res) => {
      if (res.status !== "0") return;
      const ls = getTreeData(res.data);
      if (formState.id) {
        const deviceId = findAllParents(
          ls,
          formState.gatherDevId * 1,
          [],
          "number",
          "children"
        );
        form.setFieldsValue({
          gatherDevId: deviceId,
        });
      }
      setDeviceList(ls);
    });
  };

  const getTreeData = (data) => {
    return data.map((item) => {
      return {
        ...item,
        id: item.deviceId ? item.deviceId : item.id,
        children: item.child.length ? getTreeData(item.child) : undefined,
        child: undefined,
      };
    });
  };

  const cancel = (bool) => {
    setVisible(false);
    form.resetFields();
    onCancel && onCancel(bool);
  };

  const save = () => {
    form.validateFields().then((values) => {
      const params = {
        ...values,
        gatherDevId: values.gatherDevId[values.gatherDevId.length - 1],
      };
      params.processunitId && delete params.processunitId;
      if (formState.id) {
        setConfirmLoading(true);
        SystemApi.pointIndicatorUpdate({ ...params, id: formState.id }).then(
          (res) => {
            setConfirmLoading(false);
            if (res.status !== "0") return;
            message.success("修改成功");
            cancel(true);
          }
        );
      } else {
        setConfirmLoading(true);
        SystemApi.pointIndicatorSave(params).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("新增成功");
          cancel(true);
        });
      }
    });
  };

  return (
    <Modal
      title={formState.id ? "编辑" : "新增"}
      open={visible}
      onCancel={() => cancel(false)}
      onOk={save}
      confirmLoading={confirmLoading}
    >
      <Form {...layout} form={form}>
        <Form.Item
          label="告警名称"
          name="alarmName"
          rules={[{ required: true, message: "请输入告警名称!" }]}
        >
          <Input placeholder="请输入告警名称" />
        </Form.Item>
        <Form.Item
          label="告警值"
          name="alarmValue"
          rules={[{ required: true, message: "请输入告警值!" }]}
        >
          <InputNumber style={{ width: "100%" }} placeholder="请输入告警值" />
        </Form.Item>
        <Form.Item
          label="工艺点"
          name="deviceDiyAttrId"
          rules={[{ required: true, message: "请选择工艺点!" }]}
        >
          <Select placeholder="请选择工艺点">
            {diyAttrList.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.attrName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="采集设备"
          name="gatherDevId"
          rules={[{ required: true, message: "请选择采集设备!" }]}
        >
          <Cascader
            fieldNames={fieldNames}
            options={deviceList}
            placeholder="请选择采集设备"
          />
        </Form.Item>
        <Form.Item
          label="运算符"
          name="operatorType"
          rules={[{ required: true, message: "请选择运算符!" }]}
        >
          <Select placeholder="请选择运算符">
            <Select.Option value={0}>等于</Select.Option>
            <Select.Option value={1}>大于</Select.Option>
            <Select.Option value={2}>大于等于</Select.Option>
            <Select.Option value={3}>小于</Select.Option>
            <Select.Option value={4}>小于等于</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="权重"
          name="weight"
          rules={[{ required: true, message: "请输入权重!" }]}
        >
          <InputNumber
            min={0}
            max={1}
            style={{ width: "100%" }}
            placeholder="请输入权重"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
